module.exports = __webpack_public_path__ + "img/368x150_Blizzak6.8473eaed.jpg";